 /*local */ 
// export const apiUrl      = "http://localhost/airpal/api2/";
// export const baseUrl      = "http://localhost/airpal";
// export const mediaUrl      = "http://localhost/airpal/media/";
// export const carImageUrl      = "http://localhost/airpal/media/carImage/";
// export const sampleFileUrl      = "http://localhost/airpal/media/sample_file/";
// export const cmscontentURL       = "http://localhost/airpal/media/cmscontent";
// export const tapURL       = "http://localhost/airpal/media/tabmanagement";
// export const vehicleURL       = "http://localhost/airpal/media/vehicle";
// export const chatURL       = "http://localhost/airpal/media/smilesy";
// export const categoryURL = "http://localhost/airpal/media/category";
// export const assetUrl       = "http://localhost:3000/assets/";

/*Live */

// //export const apiUrl      = "http://admin-air.uxt.design/airpal/api2/";
// export const apiUrl      = "https://admin-air.uxt.design/airpal/api_dev/";
// export const baseUrl      = "https://admin-air.uxt.design/airpal";
// export const mediaUrl      = "https://admin-air.uxt.design/airpal/media/";
// export const carImageUrl      = "https://admin-air.uxt.design/airpal/media/carImage/";
// export const sampleFileUrl      = "https://admin-air.uxt.design/airpal/media/sample_file/";
// export const cmscontentURL       = "https://admin-air.uxt.design/airpal/media/plugincontent";
// export const tapURL       = "https://admin-air.uxt.design/airpal/media/tabmanagement";
// export const vehicleURL       = "https://admin-air.uxt.design/airpal/media/vehicle";
// export const chatURL       = "https://admin-air.uxt.design/airpal/media/smilesy";
// export const categoryURL = "https://admin-air.uxt.design/airpal/media/category";
// export const assetUrl       = "https://admin-air.uxt.design/assets/";

/*Dev */

//export const apiUrl      = "http://admin.airpal.app/airpal/api2/";
export const apiUrl      = "https://admin.airpal.app/airpal/api_dev/";
export const baseUrl      = "https://admin.airpal.app/airpal";
export const mediaUrl      = "https://admin.airpal.app/airpal/media/";
export const carImageUrl      = "https://admin.airpal.app/airpal/media/carImage/";
export const sampleFileUrl      = "https://admin.airpal.app/airpal/media/sample_file/";
export const cmscontentURL       = "https://admin.airpal.app/airpal/media/plugincontent";
export const tapURL       = "https://admin.airpal.app/airpal/media/tabmanagement";
export const vehicleURL       = "https://admin.airpal.app/airpal/media/vehicle";
export const chatURL       = "https://admin.airpal.app/airpal/media/smilesy";
export const categoryURL = "https://admin.airpal.app/airpal/media/category";
export const assetUrl       = "https://admin.airpal.app/assets/";

